import { createContext, useContext } from 'react'

/**
 * What the organizer shell shares with the page it wraps:
 *  - `event`: the /event/menu summary (name, iconLink, orgaId, gates, roles, volunteeringId)
 *  - `status`: { event, ticketing, planning, leaderboard, volunteering } publish flags (the truth)
 *  - `setStatus(key, on)`: runs the mutation; `patchStatus(key, on)`: mirrors a flag written elsewhere
 *    (volunteering follows its application dates); `setIdentity({ name, iconLink })`: identity edits
 *  - `viewer`: { isOrganizer, isJudgeOnly, isCheckInAttendantOnly, isPartnerForEvent }
 *  - `menu`: the visible groups of the side menu; `isHub`: the page is the event hub (a tab or its root)
 *  - `rel`: the page's path relative to the event root ('' on the hub root, 'orders'…): the guided
 *    tours find the page's tour with it (Tours/tours.registry `tourForPath`)
 * `null` outside the shell (public visitors): consumers no-op.
 */
const OrganizerShellContext = createContext(null)

export const OrganizerShellProvider = OrganizerShellContext.Provider

export const useOrganizerShell = () => useContext(OrganizerShellContext)

export default OrganizerShellContext
